var identity = function identity(x) {
  return x;
};

export default identity;


// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/esm/utils/identity.js